<template>
  <b-card>
    <b-table 
    :items="users" 
    :busy="loading"
    :fields="fields" 
    :per-page="8"
    :current-page="currentPage"
    responsive >
    <template #table-busy>
      <div class="text-center my-3">
        <b-spinner class="mr-2" />
        <strong>Carregando usuários...</strong>
      </div>
    </template>
      <template #cell(permissions)="data">
        <b-badge
        v-for="p in data.value.filter(p => ![PERMISSIONS.ADMIN, PERMISSIONS.MASTER].includes(Number(p)))"
        :key="p"
        class="mr-1 mb-1"
      >
          {{ getLabel(p) }}
        </b-badge>
      </template>

      <template #cell(ecs)="data">
        <div class="ecs-cell">
          {{ data.value.join(", ") }}
        </div>
      </template>

      <template #cell(isAdmin)="data">
        {{ data.item.permissions.includes(PERMISSIONS.ADMIN) ? 'Sim' : 'Não' }}
      </template>
      
      <template #cell(actions)="data">
        <div class="d-flex mr-2">
          <b-button
            v-if="!isMaster(data.item) && data.item.id !== currentUserId"
            size="sm"
            variant="primary"
            class="mr-2"
            @click="$emit('edit', data.item)"
          >
            Editar
          </b-button>

          <b-button
            v-if="canDeleteUser && !isMaster(data.item)"
            size="sm"
            variant="danger"
            :disabled="deletingUserId === data.item.id"
            @click="confirmDelete(data.item)"
          >
            <b-spinner small v-if="deletingUserId === data.item.id" class="mr-1" />
            {{ deletingUserId === data.item.id ? 'Excluindo...' : 'Excluir' }}
          </b-button>
        </div>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :per-page="8"
      :total-rows="users.length"
      align="center"
      class="mt-2"
      size="sm"
    />

    <b-modal
      centered
      id="confirm-delete-modal"
      ref="confirmModal"
      title="Confirmar exclusão"
      @ok="handleDelete"
      ok-title="Excluir"
      ok-variant="danger"
      cancel-title="Cancelar"
    >
      <p>
        Tem certeza que deseja excluir o usuário
        <strong>{{ userToDelete && userToDelete.email }}</strong
        >?
      </p>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BCard,
  BSpinner,
  BTable,
  BBadge,
  BButton,
  BModal,
  BPagination,
} from "bootstrap-vue";
import { PERMISSIONS } from '@/enums/permissions'

export default {
  props: ["users", "fields", "permissionOptions", "loading", "deletingUserId", "canDeleteUser", "currentUserId"],

  components: {
    BCard,
    BSpinner,
    BTable,
    BBadge,
    BButton,
    BModal,
    BPagination,
  },

  data() {
    return {
      userToDelete: null,
      currentPage: 1,
      PERMISSIONS,
    };
  },

  methods: {
    getLabel(value) {
      const found = this.permissionOptions.find((p) => p.value === Number(value));
      return found ? found.text : value;
    },

    isMaster(user) {
      return user.permissions.includes(PERMISSIONS.MASTER)
    },

    confirmDelete(user) {
      this.userToDelete = user;
      this.$refs.confirmModal.show();
    },

    handleDelete() {
      if (this.userToDelete) {
        this.$emit("delete", this.userToDelete.id);
        this.userToDelete = null;
      }
    },
  },
};
</script>

<style scoped>
.ecs-cell {
  max-width: 300px;
  white-space: normal;
  word-break: break-word;
}
</style>